<template>
  <div id="app">
   
    <v-dialog v-model="infoDialog" width="600" persistent>
      <v-card>
        <v-card-title style="background-color: #01579b;font-size:22px;">
          <span class="white--text">Arkman Yazılım sizler için çalışmaya devam ediyor..</span>   
        </v-card-title>

          <v-card-text class="white" style="font-size:20px;">
          SİSTEMLERİMİZİ SİZLER İÇİN YENİLİYORUZ. YENİ VE DAHA GÜÇLÜ VE HARİKA ÖZELLİKLER EKLENMİŞ EKRANLARIMIZA YENİ ADRESİMİZDEN ERİŞEBİLİRSİNİZ.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="yonlendir">
             BENİ NEXT ARKMAN SİSTEMİNE GÖTÜR  <v-icon right dark>send</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
     
    </v-dialog>
    <v-dialog persistent
      no-click-animation
      v-model="userdialog"
      width="900"
      max-width="96vw"
    >
    <v-stepper v-model="s1">
    <v-stepper-header>
      <v-stepper-step :complete="s1 > 1" step="1">{{ $t('Company-Information')}}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="s1 > 2" step="2">{{ $t('Authorized_label') }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3" :complete="s1 > 3">{{ $t('User') }}</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4">{{ $t('tab_invoiceinformation') }}</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form ref="formnewuserstatus1" v-model="step1validate">
                  <v-layout v-if="newuserstatus" row wrap>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="subtitles" box="" :rules="[rules.required]" 
                        v-model="unvan" :label="$t('Title_label')" required></v-text-field>
                    </v-flex>
                    <v-flex  sm12 md12>
                      <v-select prepend-icon="subtitles" item-value="UlkeID" item-text="UlkeAdi" :label="$t('Country-of-Your-Company')"
   persistent-hint :items="ulkeitems"
    v-model="secilenUlke"   :rules="[rules.required]"  return-object  box required
>
</v-select>             
                                      
                                </v-flex>
                             
                  </v-layout>
        </v-form>
       
        <v-btn
          color="primary"
          @click="validate1(1)"  :disabled="!step1validate"
        >


          Devam
        </v-btn>

        <v-btn :disabled="yenikayitbekle" color="info" @click="geriDon()"> {{  $t('Return-v2') }}</v-btn>
       
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-form ref="formnewuserstatus2" v-model="step2validate">
                  <v-layout v-if="newuserstatus" row wrap>
        <v-flex sm12 md12>
                      <v-text-field prepend-icon="person" box="" :rules="[rules.required]" :placeholder="$t('Name_Surname_label')"
                        v-model="YeniKullanici.AdSoyad" :label="$t('Name_Surname_label')"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="email" box="" :placeholder="$t('Email_label')" v-model="YeniKullanici.email"
                        :label="$t('Email_label')" :rules="[rules.required, rules.email]"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>

        <v-btn
          color="primary"
          @click="validate2(2)"  :disabled="!step2validate"
        >
          Devam
        </v-btn>

        <v-btn color="info" @click="s1 = 1">Geri Dön</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-form ref="formnewuserstatus" v-model="step3validate">
                  <v-layout v-if="newuserstatus" row wrap>
                    <v-flex sm12 md12>
                      <v-alert :type="alerttype" :value="true" v-model="yenierrorAlert" transition="scale-transition">
                        <span>{{ yenierrorMsg }}</span>
                      </v-alert>
                    </v-flex>
        <v-flex sm12 md12>
                      <v-text-field prepend-icon="lock" box="" counter="8" :placeholder="$t('Password')"
                        v-model="YeniKullanici.Sifre" :label="$t('Password')" id="password1" :type="e3 ? 'password' : 'text'"
                        :rules="[rules.required, rules.minLength8]" :append-icon="e3 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (e3 = !e3)"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="lock" box="" counter="8" :placeholder="$t('Password-Again')" v-model="confirm"
                        :label="$t('Password')" id="password2" :type="e4 ? 'password' : 'text'" :rules="[rules.required, rules.minLength8]"
                        :append-icon="e4 ? 'visibility' : 'visibility_off'" @click:append="() => (e4 = !e4)">
                      </v-text-field>
                    </v-flex>

                   

                    <v-flex xs12 sm12 md12>
                      <v-layout justify-center="">
                        <v-progress-circular v-if="yenikayitbekle" indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </v-flex>
                  </v-layout>
        </v-form>
      

       
        <v-flex sm12 md12>
          <v-layout justify-start>

            <v-btn
          color="primary"
          @click="validate3(3)"  :disabled="!step2validate"
        >
          Devam
        </v-btn>

        <v-btn color="info" @click="s1 = 2">Geri Dön</v-btn>
</v-layout>
                      
                    
                    </v-flex>
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-form ref="formnewuserstatus" v-model="step3validate">
                  <v-layout v-if="newuserstatus" row wrap>
                    <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatUnvan" label="Ünvan*" required :rules="[v => !!v || 'Ünvan Alanı Boş Bırakılamaz']"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field v-model="YeniKullanici.VergiDairesi" label="Vergi Dairesi*" :rules="[v => !!v || 'Vergi Dairesi Boş Bırakılamaz']" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field v-model="YeniKullanici.VergiNumarasi" label="Vergi No*" :rules="[v => !!v || 'Vergi No Boş Bırakılamaz']" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field v-model="YeniKullanici.MersisNo" label="Mersis No" ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="fatAcikAdres" :rules="[v => !!v || 'Açık Adres Boş Bırakılamaz']"
          label="Açık Adres*" required rows="2"
        ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Posta Kodu" v-model="fatPostaKod" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatSehir" label="Şehir*" :rules="[v => !!v || 'Şehir Alanı Boş Bırakılamaz']" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="fatIlce" label="İlçe" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-autocomplete v-model="fatUlke"
                  :items="['Türkiye', 'KKTC']"
                  label="Ülke*" required :rules="[v => !!v || 'Ülke Alanı Boş Bırakılamaz']"
                ></v-autocomplete>
              </v-flex>

                   

                    <v-flex xs12 sm12 md12>
                      <v-layout justify-center="">
                        <v-progress-circular v-if="yenikayitbekle" indeterminate color="info"></v-progress-circular>
                        <p v-if="yenikayitbekle" transition="fade-transition" class="text-body-2 font-weight-medium pa-6" style="padding:8px;color:green;">{{ currentMessage }}</p>
                      </v-layout>
                      <v-layout justify-start="">



<v-btn :disabled="yenikayitbekle" color="info" @click="s1 = 3">Geri Dön</v-btn>
</v-layout>
                      <v-layout justify-end="">
                        
                        <v-btn :disabled="yenikayitbekle" color="info" @click="geriDon()"> {{  $t('Cancel') }}</v-btn>
                        <v-btn :visible="!yenikayitbekle" :disabled="saveUserDisable" color="info" @click="saveUser()"> {{ $t('Sign-up') }} </v-btn>
                      
                      </v-layout>
                    </v-flex>
                  </v-layout>
        </v-form>
      

       
       
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
    </v-dialog>
    <v-layout row wrap style="height:100vh">

      <v-flex xs12 sm4 md3>
        <v-card color="white" flat style="min-height:100%;">
          <v-layout row wrap align-center>
            <v-list dense>
              <v-layout row wrap align-center ma-3>

                <v-flex xs12 sm12 md12>
                  <br />
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <div class="text-xs-center" style="margin-bottom:15px;">
                    <img src="../../../assets/images/arkman.png" alt="Arkman">
                  </div>
                </v-flex>

                <v-form>
                  <v-layout v-if="loginstatus" row wrap>
                    <v-flex sm12 md12>
                      <v-alert :type="alerttype" :value="true" v-model="errorAlert" transition="scale-transition">
                        <span>{{ errorMsg }}</span>
                      </v-alert>

                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field data-test="login-email" prepend-icon="person" box="" :placeholder="$t('Email_label')" name="email"
                        v-model="Credential.email" :label="$t('Email_label')" type="text" :rules="[rules.required, rules.email]">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field data-test="login-sifre" prepend-icon="lock" box="" :placeholder="$t('Password')" name="password"
                        v-model="Credential.password" label="" id="password" v-on:keyup.13="apiLogin"
                        :type="e2 ? 'password' : 'text'" :rules="[rules.required]"
                        :append-icon="e2 ? 'visibility' : 'visibility_off'" @click:append="() => (e2 = !e2)">
                      </v-text-field>
                    </v-flex>


                    <v-flex xs6 sm6 md6>
                      <v-layout align-center justify-start>
                        <!-- {{$t('Language-select')}} -->
                        <v-menu offset-y>
                          <v-btn slot="activator" flat="">
                            <img v-if="this.locale=='tr'" style="height:32px; width:32px;"
                              src="../../../assets/images/turkey.png">
                            <img v-if="this.locale=='en'" style="height:32px; width:32px;"
                              src="../../../assets/images/english.png">
                            <img v-if="this.locale=='de'" style="height:32px; width:32px;"
                              src="../../../assets/images/germany.png">
                              <img v-if="this.locale=='deC'" style="height:32px; width:32px;"
                              src="../../../assets/images/germany.png">
                          </v-btn>
                          <v-list>
                            <v-list-tile v-for="(locale, index) in locales" :key="index">
                              <v-list-tile>
                                <v-list-tile-avatar @click="changeLanguage(locale.locale)">
                                  <!-- <img v-bind:src="locale.href" width="24px"> -->
                                  <img style="height:32px; width:32px;" :src="getImgUrl(locale.href)">
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  {{ locale.title }}
                                </v-list-tile-title>
                              </v-list-tile>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-layout>
                    </v-flex>

                    <v-flex xs6 sm6 md6>
                      <v-layout justify-end>
                        <v-btn data-test="login-giris" v-if="!bekle" color="info" @click="apiLogin">{{$t('Login')}}</v-btn>
                        <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-divider dark class="my-3"></v-divider>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout justify-start>
                        <v-layout justify-start row wrap style="margin-left:4px;">
                              <v-flex xs12 sm12 md12>
                                <v-btn  @click="newUser()" flat color="grey" >
                                  <v-icon large>group_add</v-icon> {{'Yeni Abonelik'}}
                                </v-btn>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-btn  @click="sifremiunuttum()" color="grey" flat >
                                  <v-icon large>group</v-icon> {{ $t('I-forgot-my-Password') }}
                                </v-btn>
                              </v-flex>
                            </v-layout>
                           
                        <v-list-tile>
                          <v-list-tile-action>
                            <!-- <v-layout justify-start>
                              <v-flex xs12 sm12 md12>
                                <v-btn @click="newUser()" color="grey" flat>
                                  <v-icon>group_add</v-icon> &nbsp; &nbsp; {{$t('New-User')}}
                                </v-btn>
                              </v-flex>
                             
                            </v-layout> -->
                           
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title @click.stop="newUser()" class="title grey--text">

                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>


  <v-dialog v-model="campaignDialog" max-width="700">
  <v-card class="pa-2" style="position:relative;">
    
    <v-btn
      icon
      small
      style="position:absolute; top:8px; right:8px; z-index:2;"
      @click="closeCampaignDialog"
    >
      <v-icon>close</v-icon>
    </v-btn>

    <v-img
      :src="campaignImage"
      contain
      max-height="500"
      class="grey lighten-4"
    ></v-img>
  </v-card>
</v-dialog>

                <!-- <v-form ref="formnewuserstatus" v-model="valid">
                  <v-layout v-if="newuserstatus" row wrap>
                    <v-flex sm12 md12>
                      <v-layout align-center justify-center="" row fill-height>
                        <div> <strong class="title primary--text"> {{ $t('New-user-details') }} </strong></div>
                      </v-layout>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-alert :type="alerttype" :value="true" v-model="yenierrorAlert" transition="scale-transition">
                        <span>{{ yenierrorMsg }}</span>
                      </v-alert>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="subtitles" box="" :rules="[rules.required]" :placeholder="$t('Title_label')"
                        v-model="unvan" :label="$t('Title_label')"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="person" box="" :rules="[rules.required]" :placeholder="$t('Name_Surname_label')"
                        v-model="YeniKullanici.AdSoyad" :label="$t('Name_Surname_label')"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="email" box="" :placeholder="$t('Email_label')" v-model="YeniKullanici.email"
                        :label="$t('Email_label')" :rules="[rules.required, rules.email]"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="lock" box="" counter="8" :placeholder="$t('Password')"
                        v-model="YeniKullanici.Sifre" :label="$t('Password')" id="password1" :type="e3 ? 'password' : 'text'"
                        :rules="[rules.required, rules.minLength8]" :append-icon="e3 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (e3 = !e3)"></v-text-field>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field prepend-icon="lock" box="" counter="8" :placeholder="$t('Password-Again')" v-model="confirm"
                        :label="$t('Password')" id="password2" :type="e4 ? 'password' : 'text'" :rules="[rules.required, rules.minLength8]"
                        :append-icon="e4 ? 'visibility' : 'visibility_off'" @click:append="() => (e4 = !e4)">
                      </v-text-field>
                    </v-flex>

                    <v-flex sm12 md12>
                      <v-layout justify-end="">

                        <v-btn :disabled="yenikayitbekle" color="info" @click="geriDon()"> {{  $t('Return-v2') }}</v-btn>
                        <v-btn :disabled="yenikayitbekle" color="info" @click="saveUser()"> {{ $t('Sign-up') }} </v-btn>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout justify-center="">
                        <v-progress-circular v-if="yenikayitbekle" indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                </v-form> -->
            <v-layout>

            </v-layout>

                <v-form ref="formemail" v-model="valid">
                  <v-layout v-if="emailstatus" row wrap>

                    <v-flex xs12 sm12 md12>
                      <v-text-field prepend-icon="email" box="" placeholder="E-mail" v-model="Emailyeni" :label="$t('Email_label')"
                        :rules="[rules.required, rules.email]"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout justify-end="">
                        <v-btn :disabled="sifresifirlabekle" color="info" @click="geriDon()"> {{ $t('Return-v2') }} </v-btn>
                        <v-btn :disabled="sifresifirlabekle" color="info" @click="sifresifirla()"> {{ $t('Reset-my-password') }}
                        </v-btn>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout justify-center="">

                        <v-progress-circular v-if="sifresifirlabekle" indeterminate color="info">
                        </v-progress-circular>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>


              </v-layout>
            </v-list>
            <v-col cols="12" class="mt-4" style="width:100%;">
  <v-divider class="mb-2"></v-divider>

  <div class="social-strip d-flex justify-center">
   


    <div class="d-flex align-center" style="flex: 0 1 auto !important;">
      <v-btn icon :href="social.linkedin" target="_blank" rel="noopener" aria-label="LinkedIn">
       <img style="height:32px; width:32px;" :src="getImgUrl('linkedin')">
      </v-btn>
      <v-btn icon :href="social.twitter" target="_blank" rel="noopener" aria-label="Twitter / X">
       <img style="height:32px; width:32px;" :src="getImgUrl('twitter')">
      </v-btn>
      <v-btn icon :href="social.instagram" target="_blank" rel="noopener" aria-label="Instagram">
        <img style="height:32px; width:32px;" :src="getImgUrl('instagram')">
      </v-btn>
      <v-btn icon :href="social.facebook" target="_blank" rel="noopener" aria-label="Facebook">
       <img style="height:32px; width:32px;" :src="getImgUrl('facebook')">
      </v-btn>
    </div>
  </div>
</v-col>
          </v-layout>
        </v-card>

      </v-flex>

      <v-flex xs12 sm8 md9>
        <v-container fluid height="100%" class="pa-0 d-flex flex-column">
    
    <!-- <v-carousel v direction="horizontal" height="100%" class="flex-grow-1">
      <v-carousel-item v-for="item in carouselitems"
      :key="i"
      :src="item.src">
      </v-carousel-item>
    </v-carousel> -->
    <v-carousel direction="horizontal" height="100%" class="flex-grow-1" cycle :interval="3000">
  <v-carousel-item
    v-for="(item, i) in carouselitems"
    :key="i"
  >
    <v-sheet
      height="100%"
      width="100%"
      tile
      class="d-flex align-center justify-center"
      @click="goTo(i === 1 ? 'https://calco2ai.com/?lang=tr' : 'https://www.arkman.com.tr/')"
      style="cursor:pointer"
    >
      <v-img :src="item.src" contain></v-img>
    </v-sheet>
  </v-carousel-item>
</v-carousel>
  </v-container>

     

      </v-flex>

    </v-layout>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>

  </div>

</template>

<script>
  import auth from '../../../api/auth'
  import _ from 'underscore'
  import router from '../../../router'
  import axios from 'axios'

  import {
    Trans
  } from '@/plugins/Translation'

  export default {
     data() {

        return {
        social: {
    linkedin:  'https://www.linkedin.com/company/arkmanyazilim/',   
    twitter:   'https://x.com/arkmanyazilim',        
    instagram: 'https://www.instagram.com/arkmanyazilim/',
    facebook:  'https://www.facebook.com/arkmansoftware/'
  },
           carouselitems: [
            
            {
            src: 'https://nextv3.arkman.com.tr/images/Arkmanco2.png' ,
          },
           {
            src: 'https://nextv3.arkman.com.tr/images/PaxDrive-Banner.png' ,
          },
          {
            src: 'https://nextv3.arkman.com.tr/images/Arkman11.png' ,
          },
          {
            src: 'https://nextv3.arkman.com.tr/images/Arkman22.png'
          },
          {
            src: 'https://nextv3.arkman.com.tr/images/Arkman33.png'
          },
         
        ],
          loading: false, // Yükleme durumu
      messages: [
        "Şirketiniz oluşturuluyor lütfen bekleyin.",
        "Arkman sizler için çalışmaya devam ediyor.",
        "Arkmanı seçtiğiniz için teşekkürler.",
        "Arkman'a hoş geldiniz!",
      ],
      currentMessage: "Yüklemeyi başlatmak için butona basın.",
          infoDialog:false,
          role: [
      { name: "Admin", id: 1 },
      { name: "SuperAdmin", id: 2 }
    ],
          rules: {
      select: [(v) => !!v || "Item is required"],
      select2: [(v) =>  v.length>0 || "Item is required in select 2"],
      
    },
    
    secilenUlke: {
          UlkeID: '',
          UlkeAdi: ''
        },
         
        step1validate:true,
        step2validate:true,
        step3validate:true,
        s1:0,
      s2:true,
      s2:true,
      s4:true,
      pakettip: '0',
      aylikpaket: true,
      yillikpaket: false,
      tursabpaket:false,
      userdialog:false,
      ulkeitems: [],
      locale: 'tr',
      locales: [{
          locale: 'tr',
          title: 'Türkçe',
          href: 'turkey'
        },
        {
          locale: 'en',
          title: 'English',
          href: 'english'
        },
        {
          locale: 'de',
          title: 'Deutsch',
          href: 'germany'
        },
        {
          locale: 'deC',
          title: 'Deutsch-C+',
          href: 'germany'
        },
      ],
      Emailyeni: null,
      drawer: true,
      drawerRight: true,
      right: null,
      left: null,
      alerttype: 'error',
      yenikayitbekle: false,
      sifresifirlabekle: false,
      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      emailstatus: false,
      drawer: null,
    campaignDialog: false,
dontShowAgain: false,
campaignImage: require('../../../assets/images/arkmanduyuru.jpeg'),
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      bekle: false,
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        },
        minLength8: (value) => (!!value && value.length >= 8) || 'Şifre en az 8 karakter olmalıdır'
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: true,
        MusteriBilgi: [],
        ProgramTip: 0,
        VergiNumarasi:'',
        VergiDairesi:'',
        MersisNo:''
      },
            fatUnvan:'',
            fatUlke:'',
            fatSehir:'',
            fatIlce:'',
            fatPostaKod:'',
            fatAcikAdres:'',
            unvan: null,
            confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      yenierrorMsg: '',
      yenierrorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
      }
    },
    watch: {

      'pakettip': function (value) {
        if (value == '0') {
          this.aylikpaket = true
          this.yillikpaket = false
          this.tursabpaket=false
        } else if (value=="1"){
          this.yillikpaket = true
          this.aylikpaket = false
          this.tursabpaket=false
        }
        else{
          this.yillikpaket = false
          this.aylikpaket = false
          this.tursabpaket=true;
        }
      }
    },
    props: {
      source: String
    },
    computed: {

saveUserDisable() {
 var result = this.yenikayitbekle ;
 if (!this.yenikayitbekle)
 {
   result=!this.step3validate  ;
 }
 
 
 return result;
}

},
    methods: {

      closeCampaignDialog() {
  if (this.dontShowAgain) {
    localStorage.setItem('hideCampaignDialog', 'true');
  }
  this.campaignDialog = false;
},
       goTo(link){
    window.open(link, '_blank')   
  },
      yonlendir(){
        window.location.href = 'https://nextv3.arkman.com.tr/';
      },
      startLoading() {
        var i = 1;

        setInterval(() => {
          this.currentMessage = this.messages[i++ % this.messages.length];
      }, 2000); // Mesaj geçiş süresi 3 saniye

       

     
    },
      validate1 (n) {
       
        if (this.$refs.formnewuserstatus1.validate) {
          this.s1 = 2;
        }
      },
      validate2 (n) {
        if (this.$refs.formnewuserstatus2.validate) {
          this.s1 = 3;
        }
      },
      validate3 (n) {
        if (this.$refs.formnewuserstatus.validate) {
          this.s1 = 4;
        }
      },
      sifremiunuttum() {
        this.newuserstatus = false;
        this.loginstatus = false;
        this.emailstatus = true;
      },
      changeLanguage(e) {
       
        const lang = e
        const to = this.$router.resolve({
          params: {
            lang
          }
        })
        return Trans.changeLanguage(lang).then(() => {
         this.$router.push(to.location)

          this.locale = e
        })
      },
      getImgUrl(pet) {
        // eslint-disable-next-line no-undef
        var images = require.context('../../../assets/images', false, /\.png$/)
        return images('./' + pet + ".png")
      },
      apiLogin,
      sysLogin,
      anaSirketIleri,
      newUser,
      geriDon,
      saveUser,
      saveUser2,
      epostagonder,
      sifresifirla
      
    },
    beforeMount() {
    
     
    // const hidden = localStorage.getItem('hideCampaignDialog');
//if (hidden !== 'true') {
  //this.campaignDialog = true;
//}
     
      this.$http.post(auth.API_URL + 'api/Awed/WebCountryList', null, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                      response.body.forEach((item)=>{
  if (item.ParaBirimi=='TRY')
  {
    this.ulkeitems.push(item);
  }
})
                        
                        this.secilenUlke=this.ulkeitems[0]
                       
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-WebCountryList'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-WebCountryList'
                            this.snackbar = true
                        }
                    })

    }
  }

  function epostagonder(tip, kime, token) {

    var okMail;

    if (tip != 'sifre') {

      okMail = auth.URL_MAIL + 'isl=confirmmail&email=' + kime + '&&token=' + token + this.$t('approve-your-mail-from-url-address')

    } else {

      okMail = `<a>${auth.URL_MAIL}isl=confirmsifre&email='${kime}&&token=${token}</a> ${this.$t('You-can-renew-your-passwords-url-address')}`
    }


    let formData = new FormData();

    formData.append('Konu', 'E-Posta Onay Maili')
    formData.append('to', kime)
    formData.append('formattedMessage', okMail)
    formData.append('mailType', '0')
    axios.defaults.baseURL = auth.API_URL;
    // axios.responseType = 'arraybuffer';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {

          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 = this.$t('Approval-mail-sent-registered-system-approving-your-mail')
          this.snackbar = true
        } else {
          this.text1 = this.$t('user-record-created-approval-been-sent-mail')
          this.snackbar = true
        }
      })
      .catch(function () {});

  }

  function sifresifirla() {

    if (this.$refs.formemail.validate()) {

      this.sifresifirlabekle = true

      var params = {
        Email: this.Emailyeni,
        Sifre: null,
        Token: null,
        Url: auth.URL_MAIL
      }

      this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPasswordResetNew', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.Status == true) {

          this.newuserstatus = false;
          this.emailstatus = false,
          this.loginstatus = true;

        } 

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true;

        this.sifresifirlabekle = false

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-WebPasswordReset'
          this.snackbar = true
          this.sifresifirlabekle = false

        } else {
          this.text1 = 'Service Unavailable-WebPasswordReset'
          this.snackbar = true
          this.sifresifirlabekle = false

        }
      })



    } 
  }
  function saveUser2() {

if (this.$refs.formnewuserstatus2.validate()) {
  if (this.YeniKullanici.Sifre == this.confirm) {
    this.yenikayitbekle = true;
    this.Emailyeni = this.YeniKullanici.email
    var musteribilgi = {
      Ad: this.unvan,
      UlkeAdi:this.secilenUlke.UlkeAdi,
      UlkeID:this.secilenUlke.UlkeID
    }
    var musteribilgiler = [];
    musteribilgiler.push(musteribilgi)
    this.YeniKullanici.MusteriBilgi = musteribilgiler
    var params1 = this.YeniKullanici;

    this.$http.post(auth.API_URL + 'api/Register/Create', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      if (response.body.Status == true) {

        this.epostagonder('mail', this.Emailyeni, response.body.UserToken)
        this.newuserstatus = false;
        this.loginstatus = true;
        this.yenikayitbekle = false;
        this.userdialog=false;

      } else {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true;
        this.yenikayitbekle = false;
        this.userdialog=false;
      }

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-' + this.$t('New-User')
        this.snackbar = true
        this.yenikayitbekle = false;
        this.userdialog=false;
      } else {
        this.text1 = 'Service Unavailable-' + this.$t('New-User')
        this.snackbar = true
        this.yenikayitbekle = false;
        this.userdialog=false;
      }
    })


  } else {
    this.alerttype = 'error';
    this.yenierrorMsg = this.$t('Passwords-do-not-match')
    this.yenierrorAlert = true;
  }

} 
}
  function saveUser() {
    
    
   
      if (this.YeniKullanici.Sifre == this.confirm) {
        this.startLoading();
        this.yenikayitbekle = true;
        
        if (this.fatAcikAdres==null || this.fatAcikAdres=='undefined')
      {
        this.fatAcikAdres=' ';
      }
      if (this.fatUnvan==null || this.fatUnvan=='undefined')
      {
        this.fatUnvan=' ';
      }
      if (this.fatVergiDairesi==null || this.fatVergiDairesi=='undefined')
      {
        this.fatVergiDairesi=' ';
      }
      if (this.fatVergiNo==null || this.fatVergiNo=='undefined')
      {
        this.fatVergiNo=' ';
      }
      if (this.fatPostaKod==null || this.fatPostaKod=='undefined')
      {
        this.fatPostaKod=' ';
      }
        this.Emailyeni = this.YeniKullanici.email
        var musteribilgi = {
            Ad: this.unvan,
            Ulke:this.fatUlke,
            Sehir:this.fatSehir,
            Ilce:this.fatIlce,
            Adres:this.fatAcikAdres + ' '+ this.fatVergiDairesi + ' ' + this.fatVergiNo + ' ' + this.fatPostaKod ,
            UlkeID:this.secilenUlke.UlkeID,
        }
        var musteribilgiler = [];
        musteribilgiler.push(musteribilgi)
        this.YeniKullanici.MusteriBilgi = musteribilgiler
        var params1 = this.YeniKullanici;

        this.$http.post(auth.API_URL + 'api/Register/Create', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {

            this.epostagonder('mail', this.Emailyeni, response.body.UserToken)
            this.newuserstatus = false;
            this.loginstatus = true;
            this.yenikayitbekle = false;
            this.userdialog=false;

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true;
            this.yenikayitbekle = false;
            this.userdialog=false;
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
            this.yenikayitbekle = false;
            this.userdialog=false;

          } else {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
            this.yenikayitbekle = false;
            this.userdialog=false;
          }
        })


      } else {
        this.alerttype = 'error';
        this.yenierrorMsg = this.$t('Passwords-do-not-match')
        this.yenierrorAlert = true;
      }

     
  }

  function geriDon() {
    this.newuserstatus = false;
    this.loginstatus = true;
    this.emailstatus = false;
    this.userdialog=false;
  }

  function newUser() {
    this.newuserstatus = true;
    this.userdialog=true;
    this.loginstatus = false;
  }

  function apiLogin() {
this.bekle = true;
    var credential = {
      Email: this.Credential.email,
      Password: this.Credential.password
    }
    auth.login(this, credential, this.$route.query.redirect)
    localStorage.setItem("lang",this.locale)
  
  }

  function sysLogin() {
    var earsiv = 0
    var efatura = 0
    var response = JSON.parse(window.localStorage.getItem('response'));
    var sirketler = JSON.parse(window.localStorage.getItem('sirketler'));
    window.localStorage.setItem('token', response.Token.token);

    var sirketparams = {
      SirketKodu: this.Sirket.id
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {


      earsiv = response.body.OpsiyonBilgileri.EArsiv
      efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

      var credentials = {
        AnaSirketKodu: this.AnaSirket.id,
        SirketKodu: this.Sirket.id,
        SirketAdi: this.Sirket.text,
        SirketUnvani: this.Sirket.unvan,
        Sirketler: sirketler,
        EArsiv: earsiv,
        EFatura: efatura,
        CoperSirketNo: 0
      }


      window.localStorage.setItem('credentials', JSON.stringify(credentials));



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

        let credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo: 0
        }

        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      } else {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false
        let credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo: 0,
        }
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      }
    })

    window.localStorage.removeItem('response')
    window.localStorage.removeItem('sirketler')

    router.push({
      path: '/'
    })
  }

  function anaSirketIleri() {
    var response = JSON.parse(window.localStorage.getItem('response'));

    var anaSirketBilgiler = _.findWhere(response.MusteriDbler, {
      MusteriKod: this.AnaSirket.id
    })

    if (anaSirketBilgiler.GenelSirketler.length === 0) {
      this.errorAlert = true;
      this.errorMsg = this.$t('Registered-corporations-are-not-found')
      this.e1 = 2;
    } else {
      this.errorAlert = false;
      this.e1 = 3;

      var sirketler = [];

      Object.keys(anaSirketBilgiler.GenelSirketler).forEach(key => {
        var sirket = {
          text: anaSirketBilgiler.GenelSirketler[key].SirketAdi,
          id: anaSirketBilgiler.GenelSirketler[key].SirketKodu,
          unvan: anaSirketBilgiler.GenelSirketler[key].SirketUnvani
        }
        sirketler.push(sirket)
      });
      window.localStorage.setItem('sirketler', JSON.stringify(sirketler));
      this.Sirketler = sirketler;
      this.Sirket = sirketler[0];
    }

  }
</script><style scoped>
.social-strip {
  gap: 6px;             
}</style>